import { IconProps } from './index';

const SupportChatHeadset: React.FC<IconProps> = ({ className = '', ...props }) => {
    return (
        <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M20.335 6.9999C20.8654 6.9999 21.3741 7.21061 21.7492 7.58569C22.1242 7.96076 22.335 8.46947 22.335 8.9999V12.9999C22.335 13.5303 22.1242 14.039 21.7492 14.4141C21.3741 14.7892 20.8654 14.9999 20.335 14.9999H19.273C19.0292 16.9332 18.0882 18.7111 16.6267 19.9999C15.1652 21.2887 13.2836 21.9999 11.335 21.9999V19.9999C12.9263 19.9999 14.4524 19.3678 15.5776 18.2425C16.7028 17.1173 17.335 15.5912 17.335 13.9999V7.9999C17.335 6.4086 16.7028 4.88248 15.5776 3.75726C14.4524 2.63204 12.9263 1.9999 11.335 1.9999C9.74366 1.9999 8.21754 2.63204 7.09232 3.75726C5.9671 4.88248 5.33496 6.4086 5.33496 7.9999V14.9999H2.33496C1.80453 14.9999 1.29582 14.7892 0.920747 14.4141C0.545675 14.039 0.334961 13.5303 0.334961 12.9999V8.9999C0.334961 8.46947 0.545675 7.96076 0.920747 7.58569C1.29582 7.21061 1.80453 6.9999 2.33496 6.9999H3.39696C3.64099 5.0668 4.58204 3.28917 6.04353 2.00058C7.50503 0.711979 9.38651 0.000976562 11.335 0.000976562C13.2834 0.000976562 15.1649 0.711979 16.6264 2.00058C18.0879 3.28917 19.0289 5.0668 19.273 6.9999H20.335ZM7.09496 14.7849L8.15496 13.0889C9.10804 13.6859 10.2103 14.0017 11.335 13.9999C12.4596 14.0017 13.5619 13.6859 14.515 13.0889L15.575 14.7849C14.3042 15.581 12.8345 16.0022 11.335 15.9999C9.83542 16.0022 8.3657 15.581 7.09496 14.7849Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default SupportChatHeadset;
